import { Tooltip } from "@shared/antd/tooltip";
import { notification } from "@shared/antd/notification";
import { Button } from "@shared/antd/button";
import { Modal } from "@shared/antd/modal";
import { TextArea } from "app/shared/antd/text-area";
import Notification from "../util/Notification/Notification";
import React from "react";
import { getMainStore } from "@cuba-platform/react";
import { restServices } from "../../cuba/services";
import { createIntl, IntlShape } from "react-intl";
import { messagesMapping } from "../../i18n/i18nMappings";

export type StackTraceException = {
  error: string;
  details: string;
};

const silenceNotifications = async (key: string) => {
  await restServices.userErrorSettingsService.changeShowLog(false);
  notification.close(key);
};

const showNotification = (e: StackTraceException, intl: IntlShape) => {
  const notificationKey = `open${Date.now()}`;

  const showModalButton = <Button style={{ marginRight: 20 }} onClick={() => showModal(e, notificationKey, intl)}>
    {intl.messages["system.error.details"]}
  </Button>;

  const silenceNotificationsButton = <Tooltip title={intl.messages["system.error.silence.tooltip"]} placement={"left"}>
    <Button onClick={() => silenceNotifications(notificationKey)}>
      {intl.messages["system.error.silence"]}
    </Button>
  </Tooltip>;

  Notification.error({
    message: intl.messages["system.error"],
    description: e.error,
    duration: 1000,
    style: {
      width: 600,
      marginLeft: 400 - 600,
    },
    key: notificationKey,
    btn: <>
      {showModalButton}
      {silenceNotificationsButton}
    </>,
  });
};

const showModal = (e: StackTraceException, notificationKey: string, intl: IntlShape) => {
  const content = <div style={{ maxHeight: "40vh", overflowY: "scroll" }}>
    <TextArea autosize={true} value={e.details || String(e)} readOnly style={{ color: "red" }} />
  </div>;

  notification.close(notificationKey);

  Modal.error({
    title: intl.messages["system.error"],
    centered: true,
    content: content,
    width: "80vw",
  });
};


export const handleStackTraceException = (e: StackTraceException) => {
  const intl = createIntl({
    locale: getMainStore()!.locale!,
    messages: messagesMapping[getMainStore()!.locale!] as any,
  });
  showNotification(e, intl);
};
